import React from "react";
import PropTypes from "prop-types";
import { useIntl, FormattedMessage } from "react-intl";
import StepContent from "../step-content";
import MergeErrorImage from "./error.svg";
import GoToAccountLink from "../go-to-account-link";
import VisitEbscoHelpLink from "../ebsco-help-link";
import messages from "./error-messages";

import "./error.scss";

const block = "merge-error";
const hasDetailedErrorMessages = errorMessageDescriptors =>
  Boolean(errorMessageDescriptors?.length > 0);

const Error = ({ errorMessageDescriptors, username }) => {
  const informationMessage = hasDetailedErrorMessages(errorMessageDescriptors)
    ? messages.youMustResolveIssues
    : messages.problemMergingAccounts;
  const { formatMessage } = useIntl();
  return (
    <StepContent
      stepTitle={formatMessage(messages.accountsCannotBeMerged)}
      imageUrl={MergeErrorImage}
    >
      <div className={block}>
        <p className={`${block}__information`}>
          <FormattedMessage {...informationMessage} />
        </p>
        {hasDetailedErrorMessages(errorMessageDescriptors) && (
          <ul className={`${block}__list`}>
            {errorMessageDescriptors.map(errorMessageDescriptor => (
              <li
                className={`${block}__list-item`}
                key={errorMessageDescriptor.id}
              >
                <FormattedMessage
                  {...errorMessageDescriptor}
                  values={{
                    username,
                    styledUsername: displayStyledUserName(block)
                  }}
                />
              </li>
            ))}
          </ul>
        )}
        <GoToAccountLink className={`${block}__account-link`} />
        <VisitEbscoHelpLink />
      </div>
    </StepContent>
  );
};

const displayStyledUserName = baseClassName => msg => (
  <span className={`${baseClassName}__list-item__username`}>{msg}</span>
);

Error.propTypes = {
  errorMessageDescriptors: PropTypes.arrayOf(PropTypes.object),
  username: PropTypes.string.isRequired
};

export default Error;
